import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'
import { ADD_SCENARIO_ASYNC, SAVE_SCENARIO_ASYNC } from 'containers/ScenarioForm/constants'

import {
  CATEGORY_FILTER_CHANGE,
  COPY_SCENARIO_ASYNC,
  CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC,
  CREATED_BY_FILTER_CHANGE,
  DELETE_SCENARIO_ASYNC,
  LANGUAGES_FILTER_CHANGE,
  LEVEL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SCENARIOS_REQUEST_ASYNC,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORT_PROPERTY_CHANGE,
  TYPE_FILTER_CHANGE,
} from './constants'

export default function () {
  const initialState = {
    data: {
      items: [],
    },
    page: 1,
    loader: false,
    error: null,
    search: '',
    typeFilter: [],
    levelFilter: [],
    categoryFilter: [],
    createdByFilter: [],
    languages: [],
    languagesFilter: [],
    message: null,
    sortProperty: '', // first_name-desc
    createdCampaignId: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          loader: true,
        }
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          error: null,
          page: 1,
          message: null,
        }
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          page: 1,
          loader: true,
          message: null,
          error: null,
          sortProperty: '', // first_name-desc
          typeFilter: [],
          levelFilter: [],
          categoryFilter: [],
          languagesFilter: [],
        }
      case LANGUAGES_FILTER_CHANGE:
        return {
          ...state,
          languagesFilter: action.payload.languagesArray,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case TYPE_FILTER_CHANGE:
        return {
          ...state,
          typeFilter: action.payload.typeArray,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case LEVEL_FILTER_CHANGE:
        return {
          ...state,
          levelFilter: action.payload.levelArray,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case CREATED_BY_FILTER_CHANGE:
        return {
          ...state,
          createdByFilter: action.payload.array,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case CATEGORY_FILTER_CHANGE:
        return {
          ...state,
          categoryFilter: action.payload.arr,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          message: null,
          error: null,
        }
      case SCENARIOS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          message: action.payload.isClearMessage ? null : state.message,
        }
      case SCENARIOS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            items: action.payload.data.items.reduce((acc, cur, i) => {
              acc[cur.id] = cur
              acc[cur.id].sortOrder = i
              return acc
            }, {}),
          },
          loader: false,
        }
      case SCENARIOS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: null,
          loader: false,
        }
      case SCENARIOS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false, page: 1 }
      case CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.INITIATE:
        return { ...state, loader: true }
      case CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.SUCCESS:
        return { ...state, loader: false, createdCampaignId: action.response }
      case DELETE_SCENARIO_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          message: null,
        }
      case DELETE_SCENARIO_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          message: 'Template deleted successfully!',
        }
      case DELETE_SCENARIO_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: null,
          loader: false,
        }
      case COPY_SCENARIO_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          message: null,
        }
      case COPY_SCENARIO_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          message: 'Template duplicated successfully!',
        }
      case COPY_SCENARIO_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
          message: null,
        }
      case SAVE_SCENARIO_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          message: null,
        }
      case SAVE_SCENARIO_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Template saved successfully!',
        }
      case SAVE_SCENARIO_ASYNC.ERROR:
        return {
          ...state,
          message: null,
        }
      case ADD_SCENARIO_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          error: null,
          search: '',
          typeFilter: [],
          levelFilter: [],
          categoryFilter: [],
          languagesFilter: [],
        }
      case ADD_SCENARIO_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Template created successfully!',
        }
      case ADD_SCENARIO_ASYNC.ERROR:
        return {
          ...state,
          message: null,
        }
      case ADD_SCENARIO_ASYNC.CANCEL:
        return {
          ...state,
          message: null,
        }
      default:
        return state
    }
  }
}
